import {
  ExternalLinkIcon,
  EyeIcon,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconButton,
  IconButtonColorEnum,
  InputSearch,
  SearchIcon,
  Switch,
  SwitchColorEnum,
  Tooltip,
  TooltipPositionsEnum,
  TrashDeleteIcon,
  Typography,
} from '@acceso/design-system';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { timeAgo } from '@/helpers/timeAgo';

import { MOCK_NOTIFICATION_DATA, TNotification } from '../../../mockData';

export function AppNavbarActionsDrawerFields() {
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState<TNotification[]>(MOCK_NOTIFICATION_DATA);
  const [showOnlyUnread, setShowOnlyUnread] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');

  const onChangeReadNotification = () => {
    setShowOnlyUnread(!showOnlyUnread);
  };

  useEffect(() => {
    if (showOnlyUnread) {
      setNotifications(MOCK_NOTIFICATION_DATA.filter(notification => !notification.read));
    } else {
      setNotifications(MOCK_NOTIFICATION_DATA);
    }
  }, [showOnlyUnread]);

  return (
    <div className="flex w-full flex-col gap-size-20">
      <div className="flex justify-between">
        <Switch
          checked={showOnlyUnread}
          onChange={onChangeReadNotification}
          endLabel={t('Mostrar solamente las no leídas')}
          color={SwitchColorEnum.SUCCESS}
        />

        <Tooltip help={t('Ir a notificaciones')} position={TooltipPositionsEnum.LEFT} grow>
          <IconButton color={IconButtonColorEnum.NONE_DEFAULT}>
            <ExternalLinkIcon />
          </IconButton>
        </Tooltip>
      </div>

      <InputSearch
        className="w-full min-w-[250px]"
        value={searchValue}
        onChange={event => setSearchValue(event)}
        placeholder={t('Buscar...')}
        options={{
          rightContent: {
            icon: SearchIcon,
          },
        }}
      />

      <div className="flex flex-col">
        {notifications
          .filter(notification =>
            searchValue
              ? notification.message.toLowerCase().includes(searchValue.toLowerCase())
              : true
          )
          .map(notification => (
            <div
              key={notification.id}
              className="flex flex-col justify-between gap-3 border-b-2 px-2 py-4 hover:bg-black/[.05]"
            >
              <div className="flex w-full gap-size-8">
                <img
                  src={notification.sender.avatar}
                  alt={notification.sender.name}
                  className="w-size-25 h-size-24 self-start rounded-full"
                />
                <div className="flex w-full flex-col gap-3">
                  <div className="flex w-full">
                    <div className="flex flex-col">
                      <Typography
                        color={FontColorEnum.Dark10}
                        weight={FontWeightEnum.Semibold}
                        fontSize={FontSizeEnum.Sm}
                      >
                        {notification.sender.name}
                      </Typography>
                      <Typography
                        color={FontColorEnum.Medium}
                        weight={FontWeightEnum.Regular}
                        fontSize={FontSizeEnum.Sm}
                      >
                        {'email@email.com'}
                      </Typography>
                      <Typography
                        color={FontColorEnum.Medium}
                        weight={FontWeightEnum.Regular}
                        fontSize={FontSizeEnum.Xs}
                      >
                        {timeAgo(notification.createdAt)}
                      </Typography>
                    </div>

                    <div className="flex w-full justify-end">
                      <Tooltip help={t('Ver')} grow>
                        <IconButton
                          color={IconButtonColorEnum.NONE_DEFAULT}
                          onClick={() => {
                            setNotifications(
                              notifications.map(notif =>
                                notif.id === notification.id ? { ...notif, read: true } : notif
                              )
                            );
                          }}
                        >
                          <EyeIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip help={t('Eliminar')} grow>
                        <IconButton
                          color={IconButtonColorEnum.NONE_DEFAULT}
                          onClick={() => {
                            setNotifications(
                              notifications.filter(notif => notif.id !== notification.id)
                            );
                          }}
                        >
                          <TrashDeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="flex w-full flex-col rounded-md border-2 border-neutral-40 bg-bg-primary-10 px-4 py-3">
                    <Typography
                      color={FontColorEnum.Dark10}
                      weight={FontWeightEnum.Regular}
                      fontSize={FontSizeEnum.Sm}
                    >
                      {notification.message}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
